//export const API_BASE_URL = 'http://localhost:3000';
export const API_BASE_URL = 'https://api.galactic-payments.gameday.ar.ua.la/v1';
export const TEAM_ENDPOINT = `${API_BASE_URL}/teams`;
export const SCOREBOARD_ENDPOINT = `${API_BASE_URL}/scoreboard`;
